/**
 * @desc 启用供应商
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(supplierCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierInfo/supplierEnable/${supplierCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
